"use strict";

exports.__esModule = true;
exports.Api = void 0;

var tslib_1 = require("tslib");
/* tslint:disable */


require("isomorphic-fetch");

var ApiError =
/** @class */
function () {
  function ApiError(message) {
    this.details = null;
    this.message = message;
  }

  return ApiError;
}();
/**
 *
 * @class Api
 * @param {(string)} [domainOrOptions] - The project domain.
 */


var Api =
/** @class */
function () {
  function Api() {
    this.baseUrl = 'https://api.sportnet.online/v1';
  }

  Api.prototype.serializeQueryParams = function (parameters) {
    return Object.keys(parameters).reduce(function (acc, p) {
      var param = parameters[p];

      if (typeof param === 'undefined' || param === '') {
        return acc;
      }

      return tslib_1.__spreadArrays(acc, [encodeURIComponent(p) + "=" + encodeURIComponent(String(parameters[p]))]);
    }, []).join('&');
  };

  Api.prototype.transformParameter = function (value, transformOperation) {
    switch (transformOperation) {
      case 'joinUsingPipes':
        return Array.isArray(value) ? value.join('|') : value;

      default:
        return value;
    }
  };

  Api.prototype.setBaseUrl = function (baseUrl) {
    this.baseUrl = baseUrl;
  };

  Api.prototype.appendAuthHeaders = function (headerParams) {
    var headers = new Headers(headerParams);
    return headers;
  };

  Api.prototype.request = function (method, url, body, headers, queryParameters) {
    if (headers === void 0) {
      headers = new Headers();
    }

    if (queryParameters === void 0) {
      queryParameters = {};
    }

    return tslib_1.__awaiter(this, void 0, void 0, function () {
      var queryParams, urlWithParams, form, k, response, responseContentType, err, _a;

      return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            queryParams = queryParameters && Object.keys(queryParameters).length ? this.serializeQueryParams(queryParameters) : null;
            urlWithParams = url + (queryParams ? '?' + queryParams : '');

            if (headers.get('Content-Type') === 'multipart/form-data') {
              form = new FormData();

              for (k in body) {
                form.append(k, body[k]);
              }

              body = form;
            } else if (headers.get('Content-Type') === 'application/json' && body && Object.keys(body).length > 0) {
              body = JSON.stringify(body);
            } else {
              body = undefined;
            }

            if (headers.get('Content-Type') === 'multipart/form-data') {
              headers["delete"]('Content-Type');
            }

            return [4
            /*yield*/
            , fetch(urlWithParams, {
              method: method,
              headers: headers,
              body: body
            })];

          case 1:
            response = _b.sent();
            if (!response.ok) return [3
            /*break*/
            , 2];
            responseContentType = response.headers && response.headers.get('Content-Type') || '';

            if (responseContentType.includes('application/json')) {
              return [2
              /*return*/
              , response.json()];
            } else if (responseContentType.includes('application/pdf')) {
              return [2
              /*return*/
              , response.blob()];
            } else if (responseContentType.includes('text/plain')) {
              return [2
              /*return*/
              , response.text()];
            }

            return [2
            /*return*/
            , {}];

          case 2:
            err = new ApiError(response.statusText);
            _a = err;
            return [4
            /*yield*/
            , response.json()];

          case 3:
            _a.details = _b.sent();
            throw err;
        }
      });
    });
  };
  /**
   *
   * @method
   * @name Api#organizationPPOProfiles
   */


  Api.prototype.organizationPPOProfiles = function (parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/ppo';
    var headers = new Headers();
    var queryParameters = {};
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');

    if (typeof parameters['ids'] !== 'undefined') {
      queryParameters['ids'] = parameters['ids'];
    }

    queryParameters['ids'] = this.transformParameter(queryParameters['ids']);

    if (typeof parameters['sectors'] !== 'undefined') {
      queryParameters['sectors'] = parameters['sectors'];
    }

    queryParameters['sectors'] = this.transformParameter(queryParameters['sectors']);

    if (typeof parameters['type'] !== 'undefined') {
      queryParameters['type'] = parameters['type'];
    }

    queryParameters['type'] = this.transformParameter(queryParameters['type']);
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   *
   * @method
   * @name Api#organizationPPOProfile
   */


  Api.prototype.organizationPPOProfile = function (appSpace, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/ppo/{appSpace}';
    var headers = new Headers();
    var queryParameters = {};
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{appSpace}', appSpace.toString());
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   *
   * @method
   * @name Api#organizationPPOListRelatedPPOs
   */


  Api.prototype.organizationPPOListRelatedPPOs = function (appSpace, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/ppo/{appSpace}/related-ppos';
    var headers = new Headers();
    var queryParameters = {};
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');

    if (typeof parameters['q'] !== 'undefined') {
      queryParameters['q'] = parameters['q'];
    }

    queryParameters['q'] = this.transformParameter(queryParameters['q']);

    if (typeof parameters['ppoType'] !== 'undefined') {
      queryParameters['ppoType'] = parameters['ppoType'];
    }

    queryParameters['ppoType'] = this.transformParameter(queryParameters['ppoType']);

    if (typeof parameters['relationStatus'] !== 'undefined') {
      queryParameters['relationStatus'] = parameters['relationStatus'];
    }

    queryParameters['relationStatus'] = this.transformParameter(queryParameters['relationStatus']);

    if (typeof parameters['sports'] !== 'undefined') {
      queryParameters['sports'] = parameters['sports'];
    }

    queryParameters['sports'] = this.transformParameter(queryParameters['sports']);

    if (typeof parameters['with'] !== 'undefined') {
      queryParameters['with'] = parameters['with'];
    }

    queryParameters['with'] = this.transformParameter(queryParameters['with']);
    path = path.replace('{appSpace}', appSpace.toString());
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   *
   * @method
   * @name Api#getPPORelationsStructure
   */


  Api.prototype.getPPORelationsStructure = function (appSpace, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/ppo/{appSpace}/relations-structure';
    var headers = new Headers();
    var queryParameters = {};
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');

    if (typeof parameters['ppoType'] !== 'undefined') {
      queryParameters['ppoType'] = parameters['ppoType'];
    }

    queryParameters['ppoType'] = this.transformParameter(queryParameters['ppoType']);
    path = path.replace('{appSpace}', appSpace.toString());
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   *
   * @method
   * @name Api#organizationPPOGDPRBody
   */


  Api.prototype.organizationPPOGDPRBody = function (appSpace, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/ppo/{appSpace}/gdpr';
    var headers = new Headers();
    var queryParameters = {};
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{appSpace}', appSpace.toString());
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   *
   * @method
   * @name Api#organizationPPOContactInfo
   */


  Api.prototype.organizationPPOContactInfo = function (appSpace, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/ppo/{appSpace}/contact-info';
    var headers = new Headers();
    var queryParameters = {};
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{appSpace}', appSpace.toString());
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   *
   * @method
   * @name Api#organizationPPOTheme
   */


  Api.prototype.organizationPPOTheme = function (appSpace, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/ppo/{appSpace}/theme';
    var headers = new Headers();
    var queryParameters = {};
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{appSpace}', appSpace.toString());
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   *
   * @method
   * @name Api#organizationPPOUsers
   */


  Api.prototype.organizationPPOUsers = function (appSpace, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/ppo/{appSpace}/users';
    var headers = new Headers();
    var queryParameters = {};
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{appSpace}', appSpace.toString());
    queryParameters['limit'] = 100;

    if (typeof parameters['limit'] !== 'undefined') {
      queryParameters['limit'] = parameters['limit'];
    }

    queryParameters['limit'] = this.transformParameter(queryParameters['limit']);
    queryParameters['offset'] = 0;

    if (typeof parameters['offset'] !== 'undefined') {
      queryParameters['offset'] = parameters['offset'];
    }

    queryParameters['offset'] = this.transformParameter(queryParameters['offset']);

    if (typeof parameters['relatedTo'] !== 'undefined') {
      queryParameters['relatedTo'] = parameters['relatedTo'];
    }

    queryParameters['relatedTo'] = this.transformParameter(queryParameters['relatedTo']);

    if (typeof parameters['q'] !== 'undefined') {
      queryParameters['q'] = parameters['q'];
    }

    queryParameters['q'] = this.transformParameter(queryParameters['q']);

    if (typeof parameters['affiliationDateFrom'] !== 'undefined') {
      queryParameters['affiliationDateFrom'] = parameters['affiliationDateFrom'];
    }

    queryParameters['affiliationDateFrom'] = this.transformParameter(queryParameters['affiliationDateFrom']);

    if (typeof parameters['affiliationDateTo'] !== 'undefined') {
      queryParameters['affiliationDateTo'] = parameters['affiliationDateTo'];
    }

    queryParameters['affiliationDateTo'] = this.transformParameter(queryParameters['affiliationDateTo']);

    if (typeof parameters['birthdateFrom'] !== 'undefined') {
      queryParameters['birthdateFrom'] = parameters['birthdateFrom'];
    }

    queryParameters['birthdateFrom'] = this.transformParameter(queryParameters['birthdateFrom']);

    if (typeof parameters['birthdateTo'] !== 'undefined') {
      queryParameters['birthdateTo'] = parameters['birthdateTo'];
    }

    queryParameters['birthdateTo'] = this.transformParameter(queryParameters['birthdateTo']);

    if (typeof parameters['affiliationCategory'] !== 'undefined') {
      queryParameters['affiliationCategory'] = parameters['affiliationCategory'];
    }

    queryParameters['affiliationCategory'] = this.transformParameter(queryParameters['affiliationCategory']);

    if (typeof parameters['competenceType'] !== 'undefined') {
      queryParameters['competenceType'] = parameters['competenceType'];
    }

    queryParameters['competenceType'] = this.transformParameter(queryParameters['competenceType']);
    queryParameters['affiliationActive'] = true;

    if (typeof parameters['affiliationActive'] !== 'undefined') {
      queryParameters['affiliationActive'] = parameters['affiliationActive'];
    }

    queryParameters['affiliationActive'] = this.transformParameter(queryParameters['affiliationActive']);
    queryParameters['membershipActive'] = false;

    if (typeof parameters['membershipActive'] !== 'undefined') {
      queryParameters['membershipActive'] = parameters['membershipActive'];
    }

    queryParameters['membershipActive'] = this.transformParameter(queryParameters['membershipActive']);

    if (typeof parameters['sportSector'] !== 'undefined') {
      queryParameters['sportSector'] = parameters['sportSector'];
    }

    queryParameters['sportSector'] = this.transformParameter(queryParameters['sportSector']);

    if (typeof parameters['ids'] !== 'undefined') {
      queryParameters['ids'] = parameters['ids'];
    }

    queryParameters['ids'] = this.transformParameter(queryParameters['ids']);
    queryParameters['sorter'] = 'person';

    if (typeof parameters['sorter'] !== 'undefined') {
      queryParameters['sorter'] = parameters['sorter'];
    }

    queryParameters['sorter'] = this.transformParameter(queryParameters['sorter']);
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   *
   * @method
   * @name Api#organizationPPOUser
   */


  Api.prototype.organizationPPOUser = function (appSpace, userId, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/ppo/{appSpace}/users/{userId}';
    var headers = new Headers();
    var queryParameters = {};
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    queryParameters['withRelatedAffiliations'] = false;

    if (typeof parameters['withRelatedAffiliations'] !== 'undefined') {
      queryParameters['withRelatedAffiliations'] = parameters['withRelatedAffiliations'];
    }

    queryParameters['withRelatedAffiliations'] = this.transformParameter(queryParameters['withRelatedAffiliations']);
    path = path.replace('{appSpace}', appSpace.toString());
    path = path.replace('{userId}', userId.toString());
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   *
   * @method
   * @name Api#ppoOrganizationBankAccounts
   */


  Api.prototype.ppoOrganizationBankAccounts = function (appSpace, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/ppo/{appSpace}/organization/bank-accounts';
    var headers = new Headers();
    var queryParameters = {};
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{appSpace}', appSpace.toString());
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   *
   * @method
   * @name Api#ppoOrganizationAddresses
   */


  Api.prototype.ppoOrganizationAddresses = function (appSpace, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/ppo/{appSpace}/organization/addresses';
    var headers = new Headers();
    var queryParameters = {};
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');

    if (typeof parameters['type'] !== 'undefined') {
      queryParameters['type'] = parameters['type'];
    }

    queryParameters['type'] = this.transformParameter(queryParameters['type']);
    path = path.replace('{appSpace}', appSpace.toString());
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   *
   * @method
   * @name Api#organizationInvoiceProfile
   */


  Api.prototype.organizationInvoiceProfile = function (orgId, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/organizations/{orgId}/invoice-profile';
    var headers = new Headers();
    var queryParameters = {};
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{orgId}', orgId.toString());
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   *
   * @method
   * @name Api#ppoInvoiceProfile
   */


  Api.prototype.ppoInvoiceProfile = function (appSpace, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/ppo/{appSpace}/invoice-profile';
    var headers = new Headers();
    var queryParameters = {};
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{appSpace}', appSpace.toString());
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   *
   * @method
   * @name Api#getPublicAppSpaceGroups
   */


  Api.prototype.getPublicAppSpaceGroups = function (appSpace, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/ppo/{appSpace}/user-groups';
    var headers = new Headers();
    var queryParameters = {};
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{appSpace}', appSpace.toString());
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   *
   * @method
   * @name Api#getOrganizations
   */


  Api.prototype.getOrganizations = function (parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/organizations';
    var headers = new Headers();
    var queryParameters = {};
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');

    if (typeof parameters['q'] !== 'undefined') {
      queryParameters['q'] = parameters['q'];
    }

    queryParameters['q'] = this.transformParameter(queryParameters['q']);

    if (typeof parameters['businessId'] !== 'undefined') {
      queryParameters['businessId'] = parameters['businessId'];
    }

    queryParameters['businessId'] = this.transformParameter(queryParameters['businessId']);
    queryParameters['offset'] = 0;

    if (typeof parameters['offset'] !== 'undefined') {
      queryParameters['offset'] = parameters['offset'];
    }

    queryParameters['offset'] = this.transformParameter(queryParameters['offset']);
    queryParameters['limit'] = 100;

    if (typeof parameters['limit'] !== 'undefined') {
      queryParameters['limit'] = parameters['limit'];
    }

    queryParameters['limit'] = this.transformParameter(queryParameters['limit']);
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   *
   * @method
   * @name Api#getOrganizationProfiles
   */


  Api.prototype.getOrganizationProfiles = function (orgId, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/organizations/{orgId}/profiles';
    var headers = new Headers();
    var queryParameters = {};
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{orgId}', orgId.toString());
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   * Get codelist ids
   * @method
   * @name Api#listCodelists
   */


  Api.prototype.listCodelists = function (parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/codelist';
    var headers = new Headers();
    var queryParameters = {};
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   * Get codelist
   * @method
   * @name Api#getCodelist
   */


  Api.prototype.getCodelist = function (codelist, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/codelist/{codelist}';
    var headers = new Headers();
    var queryParameters = {};
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{codelist}', codelist.toString());
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   * Get codelist
   * @method
   * @name Api#getCodelistSector
   */


  Api.prototype.getCodelistSector = function (codelist, codelistItem, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/codelist/{codelist}/{codelistItem}/sector';
    var headers = new Headers();
    var queryParameters = {};
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{codelist}', codelist.toString());
    path = path.replace('{codelistItem}', codelistItem.toString());
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };
  /**
   * Get codelist
   * @method
   * @name Api#getCodelistSectorDiscipline
   */


  Api.prototype.getCodelistSectorDiscipline = function (codelist, codelistItem, sectorItem, parameters) {
    if (parameters === void 0) {
      parameters = {};
    }

    var path = '/codelist/{codelist}/{codelistItem}/sector/{sectorItem}/discipline';
    var headers = new Headers();
    var queryParameters = {};
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    path = path.replace('{codelist}', codelist.toString());
    path = path.replace('{codelistItem}', codelistItem.toString());
    path = path.replace('{sectorItem}', sectorItem.toString());
    return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
  };

  return Api;
}();

exports.Api = Api;
exports["default"] = new Api();